module.exports = __webpack_public_path__ + "img/photography.d567f01b.jpg";